export default __webpack_public_path__ + "static/media/gnosis-logo.5f649234.svg";